export default __webpack_public_path__ + "static/media/Segla.24947375.ico";